import React, {FC, MouseEvent, ReactNode, Key, useEffect, useMemo, useRef} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import * as fa from "@fortawesome/free-solid-svg-icons";
import {AutocompleteProps} from "./types";

export const Autocomplete: FC<AutocompleteProps> = (props) =>  {
  const [search, setSearch] = React.useState("")
  const [hasFocus, setHasFocus] = React.useState(false)
  const [showAll, setShowAll] = React.useState(false)
  const [selectedPosition, setSelectedPosition] = React.useState<number>(0)
  const input = useRef<HTMLInputElement>(null)

  const selectedOptionText = useMemo(() => {
    return props.options[props.value]
  }, [props.options, props.value])

  const options = useMemo(() => Object.entries(props.options).filter(([, value]) => {
    // return value.toLowerCase().includes(search.toLowerCase())
    return value.includes(search)
  }), [props.options, search])

  const selectOption = (key: string) => {
    setSearch(props.options[key])
    props.onChange(key)
    setHasFocus(false)
    input.current?.blur()
  }


  useEffect(() => {
    if (! options[selectedPosition]) {
      setSelectedPosition(0)
    }
  }, [selectedPosition, options])

  const onItemClick = (event: MouseEvent<HTMLButtonElement>, key: string) => {
    event.preventDefault()
    selectOption(key)
  }
  const onInputFocus = () => {
    setHasFocus(true)
    setSearch("")
  }
  const onInputBlur = () => {
    setHasFocus(false)
  }

  const onInputKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "ArrowDown") {
      event.preventDefault()
      if (selectedPosition < options.length - 1) {
        setSelectedPosition(selectedPosition + 1)
      }
    }
    if (event.key === "ArrowUp") {
      event.preventDefault()
      if (selectedPosition > 0) {
        setSelectedPosition(selectedPosition - 1)
      }
    }
    if (event.key === "Enter" || event.key === "Tab") {
      event.preventDefault()
      selectOption(options[selectedPosition][0])
    }
  }

  const hidesSome = options.length > 100 && !showAll
  const sortedOptions = useMemo(() => {
    return [...options].sort(([a], [b]) => {
      if (a === "all" || a === "-1" || a === '-') return -1
      if (b === "all" || b === "-1" || b === '-') return 1
      return 0
    })
  }, [options])
  const displayOptions = hidesSome ? sortedOptions.slice(0, 100) : sortedOptions

  return <label className={"flex flex-col text-sm font-medium text-slate-900 w-full max-w-md"}>
    <div className={"flex flex-row"}>
      {(props.required === false || props.required === undefined) ? props.label
        :
        <>{props.label} <span className="text-red-500 ml-2">*</span></>
      }
    </div>
    <div className={"relative mt-1"}>
      <input
        ref={input}
        onFocus={() => onInputFocus()}
        onBlur={() => onInputBlur()}
        onKeyDown={(e) => onInputKeyDown(e)}
        className={"border-2 border-slate-200 outline-slate-700 text-black rounded-xs text-base font-normal px-2 h-10 w-full"}
        onChange={(e) => setSearch(e.target.value)}
        value={hasFocus ? search : selectedOptionText}
      />

      {/* Chevron icon*/}
      <div className={"absolute top-0 right-2 h-full flex items-center justify-end"}>
        <FontAwesomeIcon icon={fa.faChevronDown} className={"text-xs text-slate-900"} />
      </div>

      {hasFocus && <div className={"absolute top-10 left-0 w-full text-black bg-white rounded-xs shadow-xs z-10 max-h-[220px] overflow-y-scroll"}>
        <div className={"flex flex-col items-stretch"}>
          {displayOptions.map(([key, value], index) => {
            return <button key={index} className={`h-10 w-full px-4 overflow-x-hidden ${index === selectedPosition ? "bg-slate-100" : ""} hover:bg-slate-100 ${key === props.value ? "text-slate-800" : ''} text-left`} onMouseDown={(e) => onItemClick(e, key)}>
              <div className={"text-left whitespace-nowrap overflow-hidden"}>{value}</div>
            </button>
          })}
          {hidesSome && <button className={`h-10 w-full px-4 hover:bg-slate-100 text-left`}
                                onMouseDown={() => setShowAll(true)}>
            Toon meer ({options.length - 100})
          </button>}
        </div>
      </div>}
    </div>
  </label>
}


